import { apiGet, apiPost, apiPut } from "../client";

export async function fetchAdminAccounts() {
  return apiGet("/admin/accounts");
}

export async function fetchAdminAccountsDashboardSummary() {
  return apiGet("/admin/accounts/dashboard-summary");
}

export async function fetchAdminAccountById(accountId) {
  return apiGet(`/admin/accounts/${accountId}`);
}

export async function createAdminAccount(data) {
  return apiPost("/admin/accounts", data);
}

export async function updateAdminAccountStatus(accountId, status) {
  return apiPut(`/admin/accounts/${accountId}/status`, { status });
}

export async function updateAdminAccountPermissions(accountId, permissions) {
  return apiPut(`/admin/accounts/${accountId}/permissions`, { permissions });
}
